/* === BEGIN imported: customComponent/waitingTimeContent.jsx === */
import React from "react";
import {planCarLogo, smartTimeQuestionIcon} from "@img/index.js";
import {POLICY_CONSTANTS} from "@/constants/booking";
import {round1} from "@/utils/policyFormat";

export function WaitingTimeContent({onAgree, onSelectSmartTime, smartTimeValue}) {
    // Waiting allowance/rate from /trips/calculate-policies (pickup leg).
    // rate_cents_per_second is cents; /100 converts the per-hour total to dollars.
    // Clamp to 1 decimal so raw seconds → minutes never shows long fractions.
    const waitingFreeMinutes = round1(POLICY_CONSTANTS.WAITING_PICKUP_FREE_SECONDS / 60);
    const waitingPerHourDollars = round1(POLICY_CONSTANTS.WAITING_PICKUP_RATE_CENTS_PER_SECOND * 60 * 60 / 100);
    return (
        <>
            <h5>Please Ensure</h5>
            <img src={planCarLogo} alt="Info"/>
            <h6>{waitingFreeMinutes} minutes waiting is included after your selected pickup time.</h6>
            <p>After that, ${waitingPerHourDollars}/hour waiting time will be charged to your credit card</p>
            <div className="hopn-smart-time-tooltip-actions">
                <button className="hopn-add-passenger-button no-icon" onClick={onAgree}>I Agree & Continue</button>
                {smartTimeValue && (
                    <>
                        <span className="hopn-tooltip-or">OR</span>
                        <button className="hopn-add-passenger-button gray" onClick={onSelectSmartTime}>
                            <img src={smartTimeQuestionIcon} alt="Smart Time"/>
                            <span>Select Smart Time</span>
                            <span className="hopn-smart-time-value">{smartTimeValue}</span>
                        </button>
                    </>
                )}
            </div>
        </>
    );
}
/* === END === */
